<template>
  <ResearchGalleryPage
    page-title="名称变更"
    section-label="建制沿革"
    :section-route="sectionRoute"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
    :groups="groups"
  />
</template>

<script>
import ResearchGalleryPage from '@/components/ResearchGalleryPage.vue';

export default {
  name: 'LanhuMingchengbiangeng',
  components: {
    ResearchGalleryPage
  },
  data() {
    return {
      sectionRoute: {
        path: '/lanhu_jigouyulishi',
        query: { item: 'evolution-history', subitem: 'name-change' }
      },
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      groups: [
        {
          title: '名称变更',
          kicker: '1978-1997',
          columns: 3,
          items: [
            {
              src: require('./assets/html/name-1978-article.jpg'),
              caption: '1978 年 3 月 6 日《人民日报》刊发了新华社电讯稿《社科院增设新闻研究所》'
            },
            {
              src: require('./assets/html/name-request-report.jpg'),
              caption: '新闻研究所关于更改所名的请示报告'
            },
            {
              src: require('./assets/html/name-approval-1997.jpg'),
              caption:
                '1997 年 9 月，中央编办同意中国社会科学院新闻研究所更名为“中国社会科学院新闻与传播研究所”的批复'
            }
          ]
        }
      ]
    };
  }
};
</script>
